import { Component } from "../component"
import Swiper from "swiper"

export class SectionInstagram extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      swiperContainer: ".swiper",
    }
  }

  initSwiper() {
    const { swiperContainer } = this.$ui

    if (window.innerWidth < 768) {
      this.swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.79,
        spaceBetween: 20,
      })
    }
  }

  created() {
    this.initSwiper()
  }
}
